<template>
  <div>
    <!-- Header -->
    <div class="header bg-home py-1">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">

          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 860 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="860 0 860 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <section id="intro-content">
      <div class="container">

        <base-progress style="width: 80%; margin: auto" show-label type="secondary" label="Progresso" :height="4" :value="progressValue" ></base-progress>
        <div class="py-4">
          <div class="icon-category">
            <div class="bg-home">
              <small>PERGUNTAS</small>
            </div>
          </div>
          <h2 class="display-3 pt-2">Parte 2</h2>
          <p class="lead">Coloque o seletor na posição que mais representa sua opinião sobre o que está sendo dito.</p>
          <p><b>ATENÇÃO:<br />Responda com sinceridade para obter o resultado mais adequado</b></p>
        </div>
        <validation-observer v-slot="{handleSubmit}" ref="formValidator">
          <form id="qa1" class="needs-validation qa"
                @submit.prevent="handleSubmit(nextPage)">


            <div class="form-row">
              <div class="col-md-8 my-4">
                <div class="align-center">
                  <p class="form-control-label">Se as coisas não vão exatamente como planejei, mantenho a
                    calma, aplico meu plano “B” e sempre tenho também um plano “C”.

                  </p>
                </div>
                <div class="marks">
                  <div class="align-marks-mid">
                    <span>Discordo<br /> Totalmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Discordo<br /> Parcialmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Concordo<br /> Parcialmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Concordo<br /> Totalmente</span>
                  </div>
                </div>
                <range-slider
                  @change="update()"
                  class="slider"
                  min="1"
                  max="4"
                  step="1"
                  v-model="p2.q6">
                </range-slider>
                <div class="marks ticks" >
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                </div>
              </div>

              <div class="col-md-8 my-4">
                <div class="align-center">
                  <p class="form-control-label">Acredito ser melhor dando ordens do que recebendo.
                    Compreendo a importância de ser um líder e ter o poder da gestão
                    em minhas mãos.

                  </p>
                </div>
                <div class="marks">
                  <div class="align-marks-mid">
                    <span>Discordo<br /> Totalmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Discordo<br /> Parcialmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Concordo<br /> Parcialmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Concordo<br /> Totalmente</span>
                  </div>
                </div>
                <range-slider
                  @change="update()"
                  class="slider"
                  min="1"
                  max="4"
                  step="1"
                  v-model="p2.q7">
                </range-slider>
                <div class="marks ticks" >
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                </div>
              </div>

              <div class="col-md-8 my-4">
                <div class="align-center">
                  <p class="form-control-label">Tento sempre tirar minhas ideias do papel e corro atrás de cada
                    uma delas. Mesmo que as pessoas digam que não vai dar certo, eu
                    acredito.

                  </p>
                </div>
                <div class="marks">
                  <div class="align-marks-mid">
                    <span>Discordo<br /> Totalmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Discordo<br /> Parcialmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Concordo<br /> Parcialmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Concordo<br /> Totalmente</span>
                  </div>
                </div>
                <range-slider
                  @change="update()"
                  class="slider"
                  min="1"
                  max="4"
                  step="1"
                  v-model="p2.q8">
                </range-slider>
                <div class="marks ticks" >
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                </div>
              </div>

              <div class="col-md-8 my-4">
                <div class="align-center">
                  <p class="form-control-label">Minha saúde é a coisa mais importante que eu tenho na vida.
                    Tendo saúde, posso correr atrás do restante.

                  </p>
                </div>
                <div class="marks">
                  <div class="align-marks-mid">
                    <span>Discordo<br /> Totalmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Discordo<br /> Parcialmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Concordo<br /> Parcialmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Concordo<br /> Totalmente</span>
                  </div>
                </div>
                <range-slider
                  @change="update()"
                  class="slider"
                  min="1"
                  max="4"
                  step="1"
                  v-model="p2.q9">
                </range-slider>
                <div class="marks ticks" >
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                </div>
              </div>

              <div class="col-md-8 my-4">
                <div class="align-center">
                  <p class="form-control-label">Nunca tenho preguiça para realizar meus planos. Meu lema é
                    “faça agora o que você poderia fazer amanhã”, principalmente
                    porque odeio acumular tarefas.

                  </p>
                </div>
                <div class="marks">
                  <div class="align-marks-mid">
                    <span>Discordo<br /> Totalmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Discordo<br /> Parcialmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Concordo<br /> Parcialmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Concordo<br /> Totalmente</span>
                  </div>
                </div>
                <range-slider
                  @change="update()"
                  class="slider"
                  min="1"
                  max="4"
                  step="1"
                  v-model="p2.q10">
                </range-slider>
                <div class="marks ticks" >
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                </div>
              </div>

            </div>
            <div class="align-center mt-6">
              <base-button outline type="secondary" class="back-btn" @click="prevPage()">Voltar</base-button>
              <base-button type="secondary" native-type="submit">Avançar</base-button>
            </div>
          </form>
        </validation-observer>
      </div>
    </section>
    <!-- Page content -->


  </div>
</template>

<script>
import 'vue-range-slider/dist/vue-range-slider.css'
import RangeSlider from 'vue-range-slider'

export default {
  name: 'qa1',
  components: {
    RangeSlider,
  },
  data: () => ({
    validated: false,
    slider: 0,
    progressValue: 40,
    p2: {
      q6: 1,
      q7: 1,
      q8: 1,
      q9: 1,
      q10: 1,
    },
  }),
  methods: {
    prevPage () {
      this.$router.push('qa1')
    },
    update () {
      window.localStorage.setItem("p2", JSON.stringify(this.p2))
    },
    async nextPage () {
      window.localStorage.setItem("p2", JSON.stringify(this.p2))
      console.log(this.p2)
      let sum = this.p2.q6+this.p2.q7+this.p2.q8+this.p2.q9+this.p2.q10
      window.localStorage.setItem("p2sum", JSON.stringify(sum))
      await this.$router.push('qa3')
    }

  },
  created() {
    let payload = window.localStorage.getItem("p2")

    if (payload != null) {
      this.p2 = JSON.parse(payload)
    }

  }
};
</script>
<style></style>
